<div class="tiime-progress-bar-loader" [class.row]="displayMode === 'row'">
  <mat-progress-bar [mode]="mode" [color]="color" [value]="value"></mat-progress-bar>
  <div class="tiime-progress-bar-loader-text">
    <ng-content></ng-content>
  </div>
</div>
